module.exports = __webpack_public_path__ + "img/logo-bus-nuevo.a4860727.png";